module.exports = __webpack_public_path__ + "static/Verne-design-level-9186b31209b5dd086cdf9deef4016286.webp";